import { apiClient, handleApiError, isBackendEnabled } from '../client';
import { Persona } from '../types';
import { mockPersonaApi } from '../mock';

/**
 * Persona API Service
 * Handles persona list API calls
 * Uses backend API if enabled, otherwise uses mock/local data
 */
export const personaApi = {
    /**
     * Get all available personas
     */
    getPersonas: async (): Promise<Persona[]> => {
        if (!isBackendEnabled() || !apiClient) {
            if (process.env.NODE_ENV === 'development') {
                console.warn('[Persona API] getPersonas: using mock (backend disabled). Set REACT_APP_USE_BACKEND=true and restart.');
            }
            return mockPersonaApi.getPersonas();
        }

        try {
            const response = await apiClient.get<Persona[] | { data: Persona[] }>('/persona?skip=0&limit=1000');
            const data = response.data;
            return Array.isArray(data) ? data : (data as { data: Persona[] }).data;
        } catch (error) {
            throw handleApiError(error);
        }
    },
};
